var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_card"},[_c('div',{staticClass:"detail_card-title"},[_c('div',[_vm._v(_vm._s(_vm.title)),_vm._t("left")],2),_vm._t("right")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }